/* JM Adding ATC collection page 06-16-2022*/
    $(document).on('click', '.hc-form .btn:not(.cart__checkout)', function(e) {
      e.preventDefault();
      $.ajax({
        url: '/cart/add.js',
        data: $(this).closest('form').serialize(),
        dataType: 'json',
        method: 'post',
        success: function(response) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        },
        error: function(response) {
          console.log(response.responseJSON['description'])
        }
      })

    });

/*JM Added for Shipping Calculator*/
$(document).ready(function() {
  if ($('body').hasClass('template-cart')) {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: theme.strings.shippingCalcSubmitButton,
      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
      moneyFormat: theme.strings.shippingCalcMoneyFormat
    });
    document.querySelector('[data-cartshipping-submit]').addEventListener('click', e => {
      const q = (s) => document.querySelector(s);
      const shippingAddress = {};
      shippingAddress.country = q('#address_country').value || '';
      shippingAddress.province = q('#address_province').value || '';
      shippingAddress.zip = q('#address_zip').value || '';
      const shippingResponse = q('[data-cartshipping-response]');
      const shippingResponseMessage = q('[data-cartshipping-message]');
      const shippingResponseRates = q('[data-cartshipping-rates]');

      function _enableShippingButton() {
        e.target.removeAttribute('disabled');
      }

      function _disableShippingButton() {
        e.target.setAttribute('disabled', 'disabled');
      }

      function _hideShippingResponse() {
        shippingResponse.style.display = 'none';
      }

      function _showShippingResponse() {
        shippingResponse.style.display = 'block';
      }

      function _handleShippingResponse() {
        const shippingResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Hide the response so that it can be populated smoothly
        _hideShippingResponse();

        const message = shippingResponse.message || null;
        const rates = shippingResponse.rates || null;

        // Empty out contents
        shippingResponseMessage.innerHTML = '';
        shippingResponseRates.innerHTML = '';

        if (message) {
          shippingResponseMessage.innerHTML = message;
        }

        if (rates) {
          shippingResponseRates.innerHTML = rates.join('');
        }

        // Reset the calculating button so it can be used again
        _enableShippingButton();

        // No error provided
        if (!message && !rates) {
          return;
        }

        // Show the response
        _showShippingResponse();

      }


      _disableShippingButton();

      Shopify.getCartShippingRatesForDestination(shippingAddress, function(response, shippingAddress) {
        var addressBase = [];

        if (shippingAddress.zip.length) {
          addressBase.push(shippingAddress.zip.trim());
        }

        if (shippingAddress.province.length) {
          addressBase.push(shippingAddress.province);
        }

        if (shippingAddress.country.length) {
          addressBase.push(shippingAddress.country);
        }

        var address = addressBase.join(', ');

        var message = '';
        if (response.length > 1) {
          var firstRate = Shopify.Cart.ShippingCalculator.formatRate(response[0].price);
          shipping = {
            "calculate_shipping": "Calculate Shipping",
            "calculating": "Calculating",
            "customer": false,
            "multiple_rates": "We found *number_of_rates* shipping rates available for *address*, starting at *rate*.",
            "one_rate": "We found one shipping rate available for *address*.",
            "no_rates": "Sorry, we do not ship to this destination.",
            "rate_value": "*rate_title* at *rate*",
            "zip": "Zip \/ Postal Code",
            "shipment_too_heavy": "Sorry, but this shipment is too heavy to ship.",
            "error_general": "Sorry, we\u0026#39;re not able to calculate your shipping at this time."
          };

          message = shipping.multiple_rates.replace('*address*', address).replace('*number_of_rates*', response.length).replace('*rate*', '<span class="money">' + firstRate + '</span>');
        } else if (response.length === 1) {
          message = shipping.one_rate.replace('*address*', address);
        } else {
          message = shipping.no_rates;
        }

        var rates = [];
        response.forEach(function(rate) {
          var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          var rateValue = shipping.rate_value.replace('*rate_title*', rate.name).replace('*rate*', '<span class="money">' + price + '</span>');

          rates.push('<li>' + rateValue + '</li>');
        });

        _handleShippingResponse({
          message: message,
          rates: rates
        });
      });
    });
  }
});


/*JM Added for collection page drawer clear all filter*/
$(document).ready(function() {
   var uri = window.location.toString();
   setInterval(function () {
       if (window.location.href.indexOf("?filter") > -1) {
              $('#clear-all-button').on("click", function(){
              var clean_uri = uri.substring(0, uri.indexOf("?"));
              window.location.href = window.location.href.split('?')[0]; 
    		});
			$("#clear-all-button").css("display","block");
       }else{
       	$("#clear-all-button").css("display","none");
       }
    },1000);
});

/*VIP Loyalty Page Accordion*/
$(document).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    }
  }

//Hide the header for VIP
if(window.location.href === "https://altenew.com/pages/loyalty-program" || window.location.href === "https://altenew.com/pages/loyalty-program#smile-home"){
   $("section#shopify-section-template--15139178774585__main header.section-header").css("display","none");
}
});


//Searchnise Product Subscription/Sneak Peak on Search Page
$(document).ready(function () {
    if (window.location.href.indexOf("https://altenew.com/pages/search-results-page?q") > -1) {
        setTimeout(function () {
            $('#snize-search-results-grid-mode ul li').each(function () {
                const $button = $(this).find('.snize-button');
                const $labeltext = $(this).find('span.snize-pre-order');
                if ($(this).hasClass("snize-product-tag-subscription")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-sneak_peek")) {
                    $button.text("Coming soon").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-preorder_product")) {
                    $button.text("Pre-Order").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-pksubscription")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-petite")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-sskgrand-exclusive-class")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-promo_ink-cube")) {
                    $button.text("More Info").removeClass("snize-add-to-cart-button");
                } else if ($(this).hasClass("snize-product-tag-register-cta")) {
                    $button.text("Register");
                    $labeltext.text("Register");
                } else if ($(this).hasClass("snize-product-tag-join-waitlist-cta")) {
                    $button.text("Join Waitlist");
                    $labeltext.text("Join Waitlist");
                    $(this).find("span.snize-out-of-stock").css("display", "none");
                    $(this).find(".snize-price-list").css("display", "none");
                } else if ($(this).hasClass("snize-product-tag-pre-order-cta")) {
                    $button.text("Pre-Order");
                } 
                  
                  // Specific condition for retreat_2025 AND out-of-stock
                else if ($(this).hasClass("snize-product-tag-retreat_2025") && $(this).hasClass("snize-product-out-of-stock")) {
                    $(this).find("span.snize-out-of-stock").css("display", "none");
                    $(this).find(".snize-price-list").css("display", "none");
                   $button.html(`
                        <svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path>
                        </svg> Notify Me
                    `);
                } 
                
                // General out-of-stock condition
                else if ($(this).hasClass("snize-product-out-of-stock")) {
                    $button.html(`
                        <svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path>
                        </svg> Notify Me
                    `);
                }
            });
        }, 3000); // Run this after 3 seconds
    }
});

/*Pre-Order for variant option search text update 2-7-2024*/
$(document).ready(function () {
  setTimeout(function(){
   $('#snize-search-results-grid-mode ul li').each(function () {
      var listItem = $(this);
      var selectElement = listItem.find('select.snize-option.snize-option-other');
      var preOrderButton = listItem.find('.snize-button');
      selectElement.on('change', function() {
        setTimeout(function(){
        if ($("span.snize-pre-order").length) {
          $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-preorder_product .snize-button.snize-add-to-cart-button").text("Pre-Order");
        }
      }, 1000); //run this after 3 seconds
      });
   });
 }, 3000); //run this after 3 seconds
});





//Remove description for https://altenew.com/collections/stamps-bundles
$(document).ready(function () {
var collectionURL = window.location.href;
if (collectionURL == "https://altenew.com/collections/stamps-bundles" || collectionURL == "https://altenew.com/collections/pencils-pens" || collectionURL =="https://altenew.com/collections/tools-adhesives"){
    $(".rte.collection__description").css("display","none");
}
});


//Klaviyo update text on collection list 
jQuery(document).ready(function ($) {
$(".klaviyo-product-container.jm-custom-klaviyo a.btn.klaviyo-bis-trigger").html("<svg style='color: #3c3c3c' xmlns='http://www.w3.org/2000/svg' width='17' height='17' fill='currentColor' class='bi bi-envelope' viewBox='0 0 16 16'> <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' fill='#3c3c3c'></path> </svg>Notify Me");
$(".klaviyo-product-container.jm-custom-klaviyo .klaviyo-button-container").css("position","unset");
});

//Pillar Page add extra id
jQuery(document).ready(function($) {
  if ($(".pillar-pages")[0]){
    $(".page-width.page-width--narrow.page-content").attr("id","pillar-pages");
}
});

//Footer moving the currency selector above
$(document).ready(function () {
if ($(window).width() > 1100) { 
$( "#jm-footer-moved" ).appendTo( $( "div#shopify-section-footer .page-width .grid__item.footer__item--77d1c31a-e643-4483-b4d9-da6966635edf .collapsible-content__inner" ) );
}
});

//Blog Search Result
$(document).ready(function () {
var urlBlogParams = new URLSearchParams(window.location.search);
var BlogSearchType = urlBlogParams.get('type');
  if(BlogSearchType=="article"){
    $(".collection-filter__item.collection-filter__item--sort").css("display","none");
    $("span.grid-search__page-content span.h4").css({
   'font-size' : '15px',
   'letter-spacing' : 'unset',
   'text-transform' : 'capitalize',
   'font-weight' : 'bold'});
    $(".search-content .grid__item.medium-up--one-fifth.grid__item--sidebar").remove();
    $("form.input-group.search-bar.search-bar--page").remove();
    $(".search-content .grid__item.medium-up--four-fifths.grid__item--content").css("width","100%");
    $(".search-content header.section-header").html("<a href='/blogs/paper-crafting-inspiration-and-tips' style='margin-top:25px;' class='btn btn--small return-link'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-arrow-left' viewBox='0 0 50 15'><path d='M50 5.38v4.25H15V15L0 7.5 15 0v5.38z'></path></svg> BACK TO THE BLOG</a>");
  }
});


/*Option 1 for products with a lot of images horizontal view*/
$( document ).ready(function() {
    $( ".template-product .product-section .product__thumbs--below .product__thumb-item" ).each(function() {
	  var getCount = $(this).attr('data-index');
	  if(getCount > 18){
	  $(".template-product .product-section .product__thumbs--below").css({
			 'max-height': '300px',
		    'overflow-x': 'hidden',
		    'overflow-y': 'scroll',
            'position': 'relative',
            '-webkit-overflow-scrolling': 'touch'
		});
        $(".template-product .product-section .product__thumbs--below").addClass("custom-horizontal-image-view");
	}
	});
});

/*Redirect old wishlist page to the new wishlist page*/
$( document ).ready(function() {
if (window.location.href.indexOf("/iwish") > -1) {
    window.location.href="https://altenew.com/pages/wishlist";
}
});


/*VIP Program Layout Improvement 2023*/
 $( document ).ready(function() {
     const modal = document.getElementById("myModal");
  const modalImg = document.getElementById("imgContainer");
  
  $(".vip-program-2023 .column img").on("click", function() {
    const imgSrc = $(this).attr("src");
    modal.style.display = "block";
    modalImg.src = imgSrc;
  });

  // Get the <span> element that closes the modal
  const span = document.getElementsByClassName("close")[0];

  // When the user clicks on <span> (x), close the modal
  if (span) {
    span.onclick = function() {
      modal.style.display = "none";
    };
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }
  };
});

/*Layering guides page custom search 09-18-2023*/
$(document).ready(function () {
  // Store the input fields as variables
  var $barInput = $('.bar-input');
  var $layeringInstructions = $('.layering-instructions');
  var $layeringStencil = $('.layering-stencil');
  var $pressPlates = $('.press-plates');

  // Reusable function for handling accordions
  function handleAccordion(inputElement, accordionContainer, backgroundColorClass) {
    var inputVal = inputElement.val().toLowerCase();
    var accordions = accordionContainer.find('.accordion');
    var searchCount = 0;

    accordions.each(function () {
      var accordion = $(this);
      var panel = accordion.next('.panel');
      var listItems = panel.find('ul li');
      var matchCount = 0;

      listItems.each(function () {
        var listItem = $(this);
        var textContent = listItem.text().toLowerCase();

        if (!inputVal || textContent.indexOf(inputVal) > -1) {
          listItem.css('display', 'list-item');
          matchCount++;
        } else {
          listItem.css('display', 'none');
        }
      });

      if (matchCount === 0) {
        accordion.removeClass('active');
        accordion.removeClass(backgroundColorClass);
        panel.css('max-height', '0'); // Close the panel
      } else {
        accordion.addClass('active'); // Add 'active' class
        accordion.addClass(backgroundColorClass); // Add background color class
        panel.css('max-height', '1000px'); // Open the panel (adjust '1000px' as needed)
      }

      searchCount += matchCount;
    });

    if (inputVal === "") {
      accordions.removeClass('active');
      accordions.removeClass(backgroundColorClass);
      accordions.show(); // Show all accordions when the input is empty
      var panels = accordionContainer.find('.panel');
      panels.css('max-height', ''); // Reset max-height for all panels
    } else {
      accordions.not('.active').hide(); // Hide non-active accordions
    }

    if (searchCount < 318 && searchCount !== 0) {
      accordionContainer.find('.no-results').css("display", "none");
    } else if (searchCount === 0) {
      accordionContainer.find('.no-results').css("display", "block");
    }
  }

  // Attach event handlers
  $barInput.on('keyup', function () {
    handleAccordion($barInput, $('#layering-guides'), 'background-color-class1');
  });

  $layeringInstructions.on('keyup', function () {
    handleAccordion($layeringInstructions, $('#layering-instructions'), 'background-color-class2');
  });

  $layeringStencil.on('keyup', function () {
    handleAccordion($layeringStencil, $('#layering-stencil'), 'background-color-class3');
  });

   $pressPlates.on('keyup', function () {
    handleAccordion($pressPlates, $('#press-plates'), 'background-color-class3');
  });


  
  /*All links open in new tab 12/10/2024*/
  $('#layering-guides a, #layering-instructions a, #layering-stencil a, #marvelous-monthly-series a','#press-plates a').attr('target', '_blank');
  
});

//Fixed Zipify
jQuery(document).ready(function ($) {
     if($("#zp-entity-content-wrapper").length){
         $("div#shopify-section-free-shipping-bar").css("display","none");
         $("div#shopify-section-header").css("display","none");
         $("div#shopify-section-footer-promotions").css("display","none");
         $(".back-to-top").css("display","none");

      setInterval(function () {
         $("div#giftbox-root").hide();
          $("div#giftbox-root").css("opacity","0");
          $("div#smile-ui-container").hide();
          $("div#smile-ui-container").css("opacity","0");
      },1000);
  };
});

/*Promotion Page Add Newsletter Subscription*/
$( document ).ready(function() {
   $("div#shopify-section-template--15741073752121__e4018767-ab30-4443-b2c5-940cfd09c99b .newsletter__input-group span.form__submit--large").text($("div#shopify-section-template--15741073752121__e4018767-ab30-4443-b2c5-940cfd09c99b .newsletter__input-group span.form__submit--large").text().replace("Subscribe", "Sign me up!"));
  if(window.location.href != "https://altenew.com/pages/promotions"){
      $(".newsletter-section").attr('id', 'promotion-page-newsletter');
      if (window.location.href.indexOf("?contact") > -1 || window.location.href.indexOf("?customer_posted") > -1) {
       $(".newsletter-section").removeAttr('id');
       $("div#shopify-section-template--15741073752121__e4018767-ab30-4443-b2c5-940cfd09c99b .newsletter__input-group span.form__submit--large").text($("div#shopify-section-template--15741073752121__e4018767-ab30-4443-b2c5-940cfd09c99b .newsletter__input-group span.form__submit--large").text().replace("Subscribe", "Sign me up!"));
    }
    if (window.location.href.indexOf("?contact") > -1) {
      // 10152025-002 START: disable 2nd confirmation message on contact form for non-collection page
      if(window.location.href.indexOf("https://altenew.com/collections/") > -1) {
      } else {
        $("#jm-alert-notification").addClass("modal--is-active");
      }
      // 10152025-002 END
    }
  }
     $('#jm-alert-notification .modal__close .icon').click(function() {
           $("#jm-alert-notification").removeClass("modal--is-active");
      });
});

/*Set Cookies for new visitor of the website*/
$( document ).ready(function() {
  if (!Cookies.get('first_visit') || Cookies.get('first_visit') !== 'true') {
    // set the cookie with a value
    Cookies.set('first_visit', 'true', { expires: 3650 });
    // show the popup
     // var pageURLNewCustomer = window.location.href;
    //if (pageURLNewCustomer == "https://altenew.com/" || pageURLNewCustomer == "https://altenew.com"){
    //window.location.replace("https://altenew.com/pages/new-to-altenew");
 // }
  }
});

/*Hide smile and free gift widget on this page https://altenew.com/pages/new-to-altenew*/
$(document).ready(function () {
var pageURL = window.location.href;
if (pageURL == "https://altenew.com/pages/new-to-altenew"){
  setInterval(function () {
         $("div#giftbox-root").hide();
          $("div#giftbox-root").css("opacity","0");
          $("div#smile-ui-container").hide();
          $("div#smile-ui-container").css("opacity","0");
      },1000);
}
});


/*Required for newsletter form*/
$(document).ready(function(){$("div#shopify-section-footer .footer__newsletter input.footer__newsletter-input").attr("required",'true')});


/*For variant discount code 6-23-2023*/
  $(document).ready(function() {
  function updateBulletList() {
    var selectedOption = $('.template-product .variant-input-wrap select').val(); // Get the selected option value
    var bulletIndex = $('.template-product .variant-input-wrap select').prop('selectedIndex'); // Get the selected option index
    
    // Update the bullet list based on the selected option index
    $('.template-product #variantDiscountCodeList li').eq(bulletIndex).show().siblings().hide();
  }

  // Trigger the function on page load
  updateBulletList();

  // Event listener for option list change
  $('.template-product .variant-input-wrap select').change(function() {
    updateBulletList();
  });
});



/*Accessibility Trigger*/
$(document).ready(function() {
  $("a:contains('Display Accessibility Widget')").on("click", function(event) {
    event.preventDefault(); // Prevent default link behavior
    $('#accessiblyAppDialogButton').trigger('click'); // Trigger accessibility widget
  });
  $("img.accessibility-widget-icon").on("click", function(event) {
    event.preventDefault(); // Prevent default link behavior
    $('#accessiblyAppDialogButton').trigger('click'); // Trigger accessibility widget
  });
});

/*JM added these scripts to delay the reward launcher on desktop and hid the launcher for mobile except for https://altenew.com/pages/loyalty-program#smile-home page 9-7-2023*/
$(document).ready(function() {
    // Check if the screen width is greater than 768 and the URL is not one of two specific links
    if (window.innerWidth > 768 && 
        !(window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" || 
          window.location.href === "https://altenew.com/pages/loyalty-program")) {
        
        // After 1 minute, make an element with the ID "smile-ui-container" fully visible
        setTimeout(function() {
            $("#smile-ui-container").css('opacity', '1');
        }, 60000);
    } else {
        if (window.innerWidth > 768 && 
        (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" || 
          window.location.href === "https://altenew.com/pages/loyalty-program")) {
              var intervalId = setInterval(function() {
              var container = $("#smile-ui-container");
              // Check if the current style matches the desired style
              if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                  clearInterval(intervalId); // Stop the interval when styles match
              } else {
                  // Apply the styles
                  container.css('display', 'block');
                  container.css('opacity', 'unset');
              }
        }, 1000); // Repeat every 1 second (adjust as needed)
    }
    }
});

$(document).ready(function() {
    // Check if the page URL matches and if the screen width is within mobile range
    if (window.location.href === "https://altenew.com/pages/loyalty-program#smile-home" && window.innerWidth <= 768) {
        var intervalId = setInterval(function() {
            var container = $("#smile-ui-container");
            
            // Check if the current style matches the desired style
            if (container.css('display') === 'block' && container.css('opacity') === 'unset') {
                clearInterval(intervalId); // Stop the interval when styles match
            } else {
                // Apply the styles
                container.css('display', 'block');
                container.css('opacity', 'unset');
            }
        }, 1000); // Repeat every 1 second (adjust as needed)
    }
});

$(document).ready(function() {
    // Tap Cart Web Banner delayed 2 minutes
    if (window.innerWidth <= 768) {
        setTimeout(function() {
            $("div#tapcart-web-banner").css('opacity', '1');
            $("div#tapcart-web-banner").css('display', 'block');
        }, 120000);
    }
});

/*Events Calendar Updating UI*/
$(document).ready(function() {
    // Function to apply your styles
    function applyStylesToElements() {
        $(".title.tsc--eventModalLink").each(function() {
            var BGcolor = $(this).css("color");
            if (BGcolor === "rgb(140, 40, 40)") {
                $(this).css("background-color", "#95c67f");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(55, 135, 35)") {
                $(this).css("background-color", "#ce3d1a");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(66, 215, 95)") {
                $(this).css("background-color", "#6da0ed");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(20, 20, 160)") {
                $(this).css("background-color", "#907ec5");
                $(this).css("color", "#fff");
            } else {
                // For other background colors
                $(this).css("color", "#fff");
                $(this).css("background-color", "#c47da2");
            }
        });
    }
    // Function to periodically check if the target element exists and apply styles after 2 seconds if it's visible
    function checkIfElementExists() {
        var interval = setInterval(function() {
            var targetElement = $(".calendar .calendar-pagination");
            
            if (targetElement.length > 0) {
                // Target element exists, check if it's visible
                if (targetElement.is(":visible")) {
                    // Target element is visible, wait for 1 second and then apply styles
                    applyStylesToElements();
                    clearInterval(interval); // Clear the interval
                }
            }
        }, 2000); // Check every 1 second (adjust as needed)
    }

    // Check if the target element exists and is visible
    checkIfElementExists();
});

$(document).ready(function() {
    function applyStylesToEventLinks() {
        $(".title.tsc--eventModalLink").each(function() {
            var BGcolor = $(this).css("color");
            if (BGcolor === "rgb(140, 40, 40)") {
                $(this).css("background-color", "#95c67f");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(55, 135, 35)") {
                $(this).css("background-color", "#ce3d1a");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(66, 215, 95)") {
                $(this).css("background-color", "#6da0ed");
                $(this).css("color", "#fff");
            } else if (BGcolor === "rgb(20, 20, 160)") {
                $(this).css("background-color", "#907ec5");
                $(this).css("color", "#fff");
            }else {
              // For other background colors
              $(this).css("color", "#fff");
              $(this).css("background-color", "#c47da2");
          }
        });
    }
  
    $(document).on("click", ".calendar .next-month-btn, .calendar .previous-month-btn, .calendar .selected-month-btn", function(event) {
        event.preventDefault();
        var clickedButton = $(this).text();
        console.log('Month change button clicked:', clickedButton);
        setTimeout(function() {
           applyStylesToEventLinks();
        }, 2000); // Set a time delay here, 0 for immediate execution
    });
});

/*Hid HC product inside the collection 10-12-2023*/
$(document).ready(function() {
  // Loop through each element with class "collection-grid__wrapper"
  $(".template-collection .collection-grid__wrapper").each(function() {
    // Find all elements with the attribute data-product-handle equal to "hc-currency"
    $(this).find("[data-product-handle='hc-currency']").remove();
  });
});


/*Update the new/best/sale menu link*/
// $(document).ready(function() {
//     // Define the target URL
//     var targetUrl = 'https://altenew.com/collections/new';

//     // Find the anchor tag with the specific href attribute
//     var $targetAnchorDesktop = $('div#HeaderWrapper a[href="' + targetUrl + '"]');

//     // Check if the anchor tag with the specified URL exists
//     if ($targetAnchorDesktop.length > 0) {
//       // Update the text content
//        $targetAnchorDesktop.html('NEW<span class="dot">•SALE <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
//     }
//   });

// $(document).ready(function() {
//     // Define the target URL
//     var targetUrl ='https://altenew.com/collections/new';

//     // Find the anchor tag with the specific href attribute
//     var $targetAnchorMobile = $('.mobile-nav__has-sublist a[href="' + targetUrl + '"]');

//     // Check if the anchor tag with the specified URL exists
//     if ($targetAnchorMobile.length > 0) {
//       // Update the text content
//        $targetAnchorMobile.html('NEW<span class="dot">•SALE<span class="dot"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
//     }
// });

/*Show launcher when PDP points is click*/
$(document).on('click', '.pdp-loyalty-points', function(event) {
    event.preventDefault();
    
    // Get the current URL hash
    var currentHash = window.location.hash;

    // Check if #smile-home is already in the URL
    if (currentHash === '#smile-home') {
        // If #smile-home is present, remove it
        window.location.hash = '';
    } else {
        // If #smile-home is not present, add it
        window.location.hash = 'smile-home';
        $("#smile-ui-container").css('opacity', 'unset');
    }
});

/*For Black Friday Only*/
    $(document).ready(function() {
      // Add a class to the link if it contains the specified text
      $("a:contains('CYBER MONDAY SALE')").addClass("contains-black-friday");
    });

/*JM added this function for removing cart item 11-27-2023*/
$(window).on('load', function() {
  $(document).on('click', '#CartDrawer .cart__remove a', function(e) {
    e.preventDefault(); // Prevent the default link behavior

    if ($('#CartDrawer').hasClass('drawer--is-open')) {
      console.log('Click');

      var qtyInput = $(this).closest('.cart__item').find('.js-qty__num');
      qtyInput.val(0);

      // Trigger the minus button click for the specific item
      $(this).closest('.cart__item').find('.js-qty__adjust--minus').click();

      // Additional logic for each item after reducing the quantity to 0
    }
  });
});

/*Move product to wishlist then remove product to cart drawer 11-27-2023*/
  // $(document).ready(function() {
  //     // Use event delegation to handle clicks on dynamically added .wishlist-engine-cart elements
  //     $(document).on('click', '.wishlist-engine-cart', function() {
  //         // Find the corresponding .cart__remove a element and trigger its click
  //         $(this).next('.cart__remove').find('a').click(e);
  //     });

  //     // Add a click event listener to the .cart__remove a element
  //     $('.cart__remove a').on('click', function(e) {
  //         e.preventDefault(); // Prevent the default behavior of the link
  //         console.log('Cart remove link clicked!');
  //         // Add your additional logic here
  //     });
  // });

/*Dynamic PDP Loyalty Points 11-29-2023*/
// Function to get and log custom price
$(document).ready(function() {
  function getAndLogCustomPrice() {
        var selectedOption = $('select[name="id"] option:selected');
        var dpromotions = $('.shopify-section.double-points-promotions-section .dpromotions').text();
        if(dpromotions == "true"){
          var customPrice = selectedOption.attr('custompricejm')*2; //Double Points
        }else {
          var customPrice = selectedOption.attr('custompricejm'); //Default Points
        }
        //Hidden points inside the PDP when price is 0 2-15-2024
        if(customPrice > "0"){
          var pointsText = " points";
          var resultDisplay = customPrice + pointsText;
          $('span.product-points').text(resultDisplay);
          $("p.pdp-loyalty-points").css("display","block");
        }else{
          $("p.pdp-loyalty-points").css("display","none");
        }
  }

    // Get and log custom price on page load
    getAndLogCustomPrice();
  
  // Get and log custom price on select change
  $('select[name="id"]').on('change', function() {
    getAndLogCustomPrice();
  });
});

/*Hovering the bottom section from product title until the button trigger the hover effect and change the main image 11-29-2023*/
$(document).ready(function () {
         var commonParent = $('.grid-product__content');
        // Add event listener for mouseenter on .grid-product__meta and .grid-product__image-mask
        commonParent.on('mouseenter', '.grid-product__meta, .grid-product__image-mask', function () {
        console.log("Hover");

        // Find the corresponding .grid-product__secondary-image
        var currentContentElement = $(this);
        var secondaryImage = currentContentElement.closest('.grid-product__content').find('.grid-product__secondary-image');

        // Apply the animation to the found .grid-product__secondary-image
        secondaryImage.css('animation', 'fade-in .2s cubic-bezier(.26,.54,.32,1) 0s forwards');
    });

    // Add event listener for mouseleave on .common-parent (optional)
    commonParent.mouseleave(function () {
        var secondaryImage = $(this).find('.grid-product__secondary-image');
        secondaryImage.css('animation', 'none');
    });
});

/*My Stash Page*/
/*VIP Loyalty Page Accordion*/
$(document).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    }
  }

//Hide the header for VIP
if(window.location.href.startsWith("https://altenew.com/pages/my-crafting-stash")){
   $(".page-width.page-width--narrow.page-content").css("max-width","1450px");
}
});

//Clear somene's email inside the article if it contains spo@spo337.com || spo@spo 1-8-2024
   $(document).ready(function () {
      // Attach keyup event to the input element
      $('.template-article input#CommentEmail').on('keyup', function () {
        // Get the entered email value
        var enteredEmail = $(this).val();

        // Define the allowed email addresses
        var disallowedEmails = ['spo@spo337.com', 'spo@spo','spo337.com','cityofrosedalems.com','pnn9499@gmail.com'];

        // Check if the entered email is in the allowedEmails array
        if (disallowedEmails.includes(enteredEmail)) {
          // Clear the input field if the email is present in the allowedEmails array
          $(this).val('');
        } 
      });
    });

//Currency Converter removed unwanted character for Qatar, Saudi Arabia, UAE
$(document).ready(function() {
    // Iterate through each list item
    $("#CurrencyList-footer .disclosure-list__item").each(function() {
      // Get the text content of the disclosure-list__label span within the current list item
      var labelText = $(this).find(".disclosure-list__label").text();

      // Remove ر.س and د.إ using replace and remove space before closing parenthesis
      var updatedText = labelText.replace(/ر\.س|د\.إ|ر\.ق/g, '').replace(/\s+\)/, ')');

      // Update the text content of the span within the current list item
      $(this).find(".disclosure-list__label").text(updatedText);
    });

    //Selected text
    // Get the text content of the disclosure-list__label span within the button
    var labelText = $(".faux-select .disclosure-list__label").text();

    // Remove ر.س, د.إ, and ر.ق using replace and remove space before closing parenthesis
    var updatedText = labelText.replace(/ر\.س|د\.إ|ر\.ق/g, '').replace(/\s+\)/, ')');

    // Update the text content of the span within the button
    $(".faux-select .disclosure-list__label").text(updatedText);
  });

//Courses list page 2-27-2024
document.addEventListener('onCoursesRendered',() =>
{
if(document.querySelector('.coursesSearchElement'))
{
document.querySelector('.coursesSearchElement').placeholder = 'Find your classes';
}
var sortedArray = Object.entries(productsBlock).sort((a,b) => { return (a[1].newest_ordertime < b[1].newest_ordertime)? 1 : -1;})
sortedArray.map((element,i) =>
{
if(document.querySelector('.courseBlock:has(button[data-prod-id="'+element[0]+'"])'))
{
document.querySelector('.courseBlock:has(button[data-prod-id="'+element[0]+'"])').setAttribute('data-attr-order',i);
}
})
var indexes = document.querySelectorAll(".courseBlock[data-attr-order]");
var indexesArray = Array.from(indexes);
var sorted = indexesArray.sort(function comparator(a, b) {
if (parseInt(a.dataset.attrOrder) < parseInt(b.dataset.attrOrder))
return -1;
if (parseInt(a.dataset.attrOrder) > parseInt(b.dataset.attrOrder))
return 1;
return 0;
});
sorted.forEach(e => document.querySelector(".appendWrapper.row").appendChild(e));
});

//Wishlist count
// Add tooltip to .wishlist-count on hover
setTimeout(function() {
   $(document).ready(function(){
    var total = $('.wishlist-count').data('total');
     if(total > 50){
       var tooltipText = 'Number of times this product has been added to wishlist.';
         $('.wishlist-count').attr('title', tooltipText);
         $("span.wishlist-count").css("color","#d2ae67");
     }else{
       $("span.wishlist-count").css("display","none");
     }
  });
}, 6000);


/*JM added 4-26-2024 - Redirect subscription products if it is 404*/
  $( document ).ready(function() {
     var checkClass = $(".section-header--404");
      if (checkClass.length > 0){
       var currentUrl = window.location.href;
       var urlParts = currentUrl.split("/");
       var lastPart = urlParts[urlParts.length - 1];
        if(lastPart == "ultimate-subscription-plan" || lastPart == "craft-your-life-project-kit-monthly-subscription-plan" || lastPart == "build-a-garden-monthly-subscription-plan" || lastPart == "craft-a-flower-monthly-subscription-plan" || lastPart == "mini-delight-monthly-subscription" || lastPart == "dynamic-duo-subscription-plan" || lastPart == "stencil-art-bi-monthly-subscription-plan" || lastPart == "build-a-garden-monthly-subscription-plands") {
         $("header.section-header.section-header--404 img").attr("src", "https://cdn.shopify.com/s/files/1/0388/7541/files/Subscription-404-page-graphics-latest.jpg?v=1715053152");
        }
      }
  });

/*JM added 7-18-2024 to dsiable other variant options except for Complete Bundle inside the PDP and Search Result Page*/
  $(document).ready(function() {
     if (window.location.href.indexOf("https://altenew.com/pages/search-results-page?q") > -1) {
      setTimeout(function() {
        $('#snize-search-results-grid-mode ul li').each(function () {
         if ($(this).hasClass("snize-product-tag-complete_bundle_enabled_only")) {
              $(this).find(".snize-option-selector-wrapper select").each(function() {
                      $(this).find('option').each(function(index) {
                        console.log(index);
                          if (index !== 0) {
                              $(this).attr('disabled', 'disabled');
                          }
                      });
                  });
              }
          });
      }, 5000);
    };
  });

/*JM added for project ideas on scroll 7-2-2024*/
$(document).ready(function(){
   $(".project_photo_count").click(function(){
      $('html, body').animate({
         scrollTop: $("#project_photo_how_to").offset().top - 120
      }, 1000); // The number 1000 represents the duration of the animation in milliseconds
   });
});

/*JM added to move the US currency selector on top 8/12/2024*/
 $(document).ready(function(){
    $('#CurrencyList-footer a[data-value="US"]').closest('li').prependTo('#CurrencyList-footer'); 
});

/*JM added for artitry logo beside the coloring essentials menu 8/23/2024*/
/*Desktop*/
//  $(document).ready(function() {
//     // var updatedText = '<a href="/collections/coloring-essentials" class="site-nav__dropdown-link site-nav__dropdown-link--top-level">Coloring Essentials</a><img src="https://cdn.shopify.com/s/files/1/0388/7541/files/ArtistryLogo.jpg?v=1723536652">';
//     var updatedValue = '<div class="menu-text"><a href="/collections/coloring-essentials" class="site-nav__dropdown-link site-nav__dropdown-link--top-level">Coloring Essentials</a></div><div class="menu-image"><a href="/collections/coloring-essentials"><img src="https://cdn.shopify.com/s/files/1/0388/7541/files/ArtistryLogo.jpg?v=1723536652"></a></div>';
//    $('.grid__item.medium-up--one-fifth.appear-animation.appear-delay-5 .h5').html(updatedValue);
// });

/*Mobile*/
// $(document).ready(function() {
//    var updatedValueMobile = '<div class="menu-text">Coloring Essentials</div> <div class="menu-image"><img src="https://cdn.shopify.com/s/files/1/0388/7541/files/ArtistryLogo.jpg?v=1723536652"></div>';
//    $("li.mobile-nav__item.appear-animation.appear-delay-2 .mobile-nav__sublist .mobile-nav__item:last-child .mobile-nav__child-item a").html(updatedValueMobile);
// });


 
/*JM added to move the US currency selector on top for pop-up 9/19/2-24*/
$(document).ready(function() {
    // Function to move the US option to the top
    function moveUSToTop() {
        var usOption = $('select.recommendation-modal__selector--flag option[value="US"]');
        
        if (usOption.length) {
            usOption.prependTo('select.recommendation-modal__selector--flag');
            console.log("US option moved to the top");
        }
    }

    // Check for the cookie and set up the interval
    setTimeout(function() {
        let localeBarAccepted = getCookie("locale_bar_accepted");
        
        if (!localeBarAccepted) {
            // Set interval to run every 3 seconds
            setInterval(moveUSToTop, 2000); // 3000 milliseconds = 3 seconds
        }
    }, 4000); // Initial delay of 4 seconds
});

// Function to get a cookie by name
function getCookie(name) {
    let cookieArr = document.cookie.split(';');
    
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split('=');
        
        if (name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}

/*Displaying disclaimer text for alcohol markers collection when access for non-us customers in relation to marktets pro app restrictions 10/9/2024*/
 jQuery(document).ready(function($) {
  const path = window.location.pathname;

  $.ajax({
    url: 'https://get.geojs.io/v1/ip/geo.json',
    dataType: 'json',
    success: function(data) {
      const country_code = data.country_code;
      const continent_code = data.continent_code;

      if (country_code !== "US") {
         if (
          path.includes("alcohol-markers") ||
          path.includes("artist-markers") ||
          path.includes("alcohol-inks") ||
          path.includes("alcohol-markers-inks-bundle")
        ) {
          $(".main-content").css("min-height", "auto");
          $(".template-collection .rte.collection__description").before(
            "<p class='disclaimerCollection'>Oops! The products in this collection cannot be shipped outside of the U.S. We know it's a bummer, but don't let it hinder your creativity!<br/> Click <a href='https://altenew.com/pages/artistrybyaltenew'>HERE</a> to browse more unique crafting goodies.</p>"
          );
        }

        $("a.monthly-subscription-button").css("display", "inline-block");
      }

      if (continent_code !== "EU") {
        $(".gpsr-container").hide();
      }
    },
    error: function() {
      console.warn("GeoJS request failed");
    }
  });
});


  /*Hide/Show Notify Me When Available For Variant Options improve to handle pre-order options 2-8-2024*/
 $( document ).ready(function() {
   var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
    if ($.trim(PDP_btn_text) == "Add to cart"){
           $("#notify-me-variant-options").css("display","none");
           $(".dropdown-moved .variant-input-wrap select option").removeAttr("disabled"); /*JM changed the class to dropdown-moved  due to moving the element from left to right 1-22-2025*/
      }else{
         $("#notify-me-variant-options").css("display","block");
         $(".dropdown-moved.variant-input-wrap select option").removeAttr("disabled"); /*JM changed the class to dropdown-moved  due to moving the element from left to right 1-22-2025*/
         $(".inventoryWrapper").css("display","none");
      }
   
       // Function to synchronize selections between Select 1 and Select 2
        function syncSelectOptions() {
            // Get the selected index from Select 1
            var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').prop('selectedIndex');
            // Set the corresponding option in Select 2 as selected
            $('select.product-single__variants.no-js').prop('selectedIndex', selectedIndex);
        }

        // Run the function when the page loads
        syncSelectOptions();

   
          // Function to check the selected option
          function checkSelectedOption() {
               var selectedOption = $('option:selected', 'select.product-single__variants.no-js');
               var attributeValue = selectedOption.attr('continuesellingoos');
               var ProductTypeJM = $("input.ProductTypeJM").val();
               var PreOrderJM = $("input.PreOrderJM").val();
               var RegisterJM = $("input.RegisterJM").val();
               var JoinWaitListJM = $("input.JoinWaitListJM").val();
                 if(attributeValue=="continue"){
                   if ( ProductTypeJM !== "Class Bundle" && ProductTypeJM !== "Workshop"  && ProductTypeJM !== "Gift Cards" && RegisterJM === "false")  {
                     $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Pre-Order");
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("PRE-ORDER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }else if(RegisterJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Register");
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("REGISTER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }
                   else if(JoinWaitListJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Join Waitlist");
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("Join Waitlist");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                }
                 }else if(attributeValue=="deny"){
                   $("h2.shipping-period").css("display","none");
                   $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Add to Cart");
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("ADD TO CART");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                 }else {
                   if(attributeValue=="oos" && JoinWaitListJM != "true"){
                    $("h2.shipping-period").css("display","none");
                    $("#notify-me-variant-options").css("display","block");
                    $(".inventoryWrapper").css("display","none");
                    $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("SOLD OUT");
                     $("div#custom-sticky-header-jm button").prop('disabled', true);
                     $("div#custom-sticky-header-jm button span").text("SOLD OUT");
                     $("div#custom-sticky-header-jm button").css("background-color","#d3d3d3");
                    $("div#custom-sticky-header-jm button").css("border","1px solid #d3d3d3");
                     $("div#custom-sticky-header-jm button").css("color","#3c3c3c");
                  }else if(attributeValue=="oos" && JoinWaitListJM == "true"){
                     $(".product-single__form .add-to-cart.btn--secondary:disabled").css("display","none");
                  }
              }
          }
    // Attach change event handler
    $('select.product-single__variants.no-js').change(function() {
      checkSelectedOption();
    });
    setTimeout(function() { 
      checkSelectedOption();
      }, 3000);
});

/*Searchanise on key up for instant search widget 12-18-2024*/
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        $(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
             $('#snize-instant-search-results ul li').each(function () {
                //const $button = $(this).find('.snize-button');
                const $labeltext = $(this).find('span.snize-pre-order');
                const $labeltextOOS = $(this).find('span.snize-out-of-stock');
                const $priceList = $(this).find('.snize-price-list');
                if ($(this).hasClass("snize-product-tag-register-cta")) {
                    $labeltext.text("Register");
                } 
                else if ($(this).hasClass("snize-product-tag-join-waitlist-cta")) {
                    $labeltext.text("Join Waitlist");
                    $labeltextOOS.text("Join Waitlist");
                   $priceList.css("display","none");
                } 
            });
        });
    })(window.Searchanise.$);
});

/*Products Countdown Timer 1/8/2024*/
    $(document).ready(function () {
      var countdownTimer = $(".countdown-container").data('countdown-timer');
       if (countdownTimer) {
          // Explicitly define the target end time in New York time
      let targetEndTime = countdownTimer;
  
      // Parse the target time into a Date object
      let countdownDate = new Date(
          new Intl.DateTimeFormat("en-US", {
              timeZone: "America/New_York",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
          }).format(new Date(targetEndTime))
      );
  
      // Start the countdown
      var x = setInterval(function () {
          // Get the current time in New York time
          let now = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
          now = new Date(now);
  
          // Calculate the remaining time
          let distance = countdownDate - now;
  
          if (distance >= 0) {
              let days = Math.floor(distance / (1000 * 60 * 60 * 24));
              let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
              $('#countdown').html(`${days}d ${hours}h ${minutes}m ${seconds}s`);
          } else {
              clearInterval(x);
              $('.countdown-container').css("display","none");
          }
          }, 1000);
       }
  });

/*JM added this to update the chat icon image 1/9/2025*/
var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function () { 
    var timer = setInterval(function () { 
        var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head'); 
        if (!chatButtonHead?.children.length) { 
            return; 
        } 
        clearInterval(timer); 

        var chatButtonIframe = document.querySelector('#chat-button'); 
        chatButtonIframe.style = "display:none;" 
        var myButton = document.createElement('img');
        myButton.style = ` 
            position: fixed; 
            right: 45px;
            bottom: 20px; 
            z-index: 3147483000; 
            width: 60px; 
            height: 60px; 
            border-radius: 10px; 
            cursor: pointer;
            ` 
        myButton.src = 'https://cdn.shopify.com/s/files/1/0388/7541/files/Chat-Icon.png?v=1736438053';  // Replace with the path to your icon image
        myButton.alt = 'Chat Icon';  // Optional, for accessibility purposes

        // Add a class to the image
        myButton.classList.add('custom-chat-icon');

        // onClick, behave like a chat opener 
        myButton.onclick = function () { 
            if (GorgiasChat.isOpen()) { 
                GorgiasChat.close(); 
            } else { 
                GorgiasChat.open(); 
            } 
        } 
        document.body.appendChild(myButton); 
    }, 50); 
});

/*Loop Widget Placement 1-20-2025*/
$( document ).ready(function() {
    $(".loop-widget-container").insertBefore(".jmc-cart-wishlist.right .payment-buttons button");
});

/*Open the sign-up and save mobile on footer 2/6/2025*/
$(document).ready(function () {
    checkAndClick();
});

function checkAndClick() {
    var $button = $('[data-type="newsletter"] button');
     if (window.innerWidth <= 768) {
        $('.footer__newsletter-input').removeAttr('required');
        $button.trigger('click');

       $(".grid__item.footer__item--1494292487693").insertAfter(".grid__item.footer__item--aeaf4542-18cd-430d-a74e-8e205ebb48f1");
       $(".shipping-date-holder").insertAfter(".payment-buttons");/*Added this for shipping order date on mobile 2-18-2025*/
       $(".inventoryWrapper").insertAfter(".payment-buttons"); /*Added for the inventory count on mobile 2-19-2025*/
       $(".inventoryWrapper").css({'display' : 'inline-block', 'width' : '100%'}); /*Added for the inventory count on mobile 2-19-2025*/

       //Blog Menu
       $(".template-blog li.mobile-nav__item.appear-animation.appear-delay-7 .mobile-nav__toggle button, .template-article li.mobile-nav__item.appear-animation.appear-delay-7 .mobile-nav__toggle button").click();
       $(".template-blog div#Linklist-https-altenew-com-blogs-paper-crafting-inspiration-and-tips6, .template-article div#Linklist-https-altenew-com-blogs-paper-crafting-inspiration-and-tips6").css("height","165px");
    }
}


/*Open the current live event 3-3-2025*/
  $(document).ready(function () {
    setTimeout(() => {
        $(".calendar-date.today.current-month.has-events").trigger("click");
    }, 3500);

    $(".calendar").on("click", ".calendar-date.today.current-month.has-events", function () {
        setTimeout(() => {
             $(".tsc--eventModalLink").trigger("click");
        }, 3500);
    });
});

/*Update the Privacy Policy Page Title*/
 $(document).ready(function () {
    let titlePrivacyPolicy = $(".shopify-policy__title h1");
    let titledatasalesoptOut = $("header.hc-header.section-header h1.section-header__title");
    let titledatasalesoptOutnav = $("nav.breadcrumb span:nth-child(3)");
   
    if (titlePrivacyPolicy.text().trim() === "Privacy policy") {
        titlePrivacyPolicy.text("Privacy Notice");
    }

    if (titledatasalesoptOut.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOut.text("Do Not Sell or Share My Personal Data");
    }

    if (titledatasalesoptOutnav.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOutnav.text("Do Not Sell or Share My Personal Data");
    }

});

/*JM added to add class for Join waitlist CTA  on PDP*/
$(document).ready(function() {
    $(".notifyme-jm-custom").each(function() {
        if ($(this).find("a").text().trim() === "Join Waitlist") {
            $(this).addClass("join-waitlists");
        }
    });
});

/*JM added for bundle listing description will show 4/30/2025*/
$(document).ready(function () {
  var firstLoad = true;

  function updateSelectedIndex() {
    var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select option:selected').index()+1;

    // Hide all tabcontent elements with data-index
    $('.tabcontent[data-index]').hide().addClass('hc-hidden');

    // Show the matching one
    var $targetTab = $('.tabcontent[data-index="' + selectedIndex + '"]');
    $targetTab.show();

    // Handle height adjustment and visibility
    function showAndAdjust() {
      // Hide others just in case
      $('.tabcontent[data-index]').not('[data-index="' + selectedIndex + '"]').css('display', 'none');

      // Reveal the selected one properly
      $targetTab.removeClass('hc-hidden').css('display', 'contents');

      var $activeContentInner = $targetTab.find('.collapsible-content__inner.rte');
      var contentHeight = $activeContentInner.outerHeight(true);

      $('#jm-desc-block .single__meta_desc').css('height', 'auto').height(contentHeight);
    }

    // Delay only on first load
    if (firstLoad) {
      setTimeout(showAndAdjust, 3000);
      firstLoad = false; // Ensure delay doesn't happen again
    } else {
      showAndAdjust();
    }
  }

  // Run on page load
  updateSelectedIndex();

  // Run on change
  $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').on('change', updateSelectedIndex);
});

      /*JM added for subcription products when hovering the subscribe and save 5-1-2025*/
$(document).ready(function() {
  setTimeout(function() {
    $("<div class='subcribe-save-tooltip-text'><div class='subcribe-save-tooltip-text-arrow'></div><div><p><strong>Disclaimer:</strong> <br/> If you already have an active subscription, please click <a href='https://altenew.myshopify.com/a/loop_subscriptions/auth?customer_id=1&myshopify_domain=altenew.myshopify.com&locale=en&source=CUSTOMER_ACCOUNT' target='_blank' style='color:#ffffff;text-decoration:underline;'>here</a> to check your subscription status. Continuing without reviewing your current plan may result in a duplicate charge.</p></div></div>").prependTo("[data-loop-widget-selling-plan-group]");
  
      //JM added for points update for subscription related products 7/17/2025
      if ($(".loop-widget-container").length && !$(".loop-widget-container").hasClass("loop-display-none")) {
       var optionPrice = $(".loop-widget-purchase-option.loop-widget-purchase-option-selected .loop-widget-purchase-option-price").text();
        // Remove $ and trailing decimals
        optionPrice = optionPrice.replace(/\$/g, "").trim();      // Remove $
        optionPrice = optionPrice.split(".")[0];                  // Remove decimal and after
       $(".template-product p.pdp-loyalty-points span.product-points").text(optionPrice + ' points');
    } 
    
   $(document).on("click", ".loop-widget-purchase-option, .loop-widget-purchase-option-radio", function () {
  // Find the closest .loop-widget-purchase-option (handles both direct and nested clicks)
  var parentOption = $(this).closest(".loop-widget-purchase-option");

  // Wait a moment in case Loop's JS updates the class after click
  setTimeout(function () {
    if (parentOption.hasClass("loop-widget-purchase-option-selected")) {
      var optionPrice = parentOption.find(".loop-widget-purchase-option-price").text();

      // Clean the price
      optionPrice = optionPrice.replace(/\$/g, "").trim().split(".")[0];

      $(".template-product p.pdp-loyalty-points span.product-points").text(optionPrice + " points");
    }
  }, 10);
});
  },4000);
});

/*Affiliate registration form 5/9/2025 */
$(document).ready(function(){
  $("section#shopify-section-template--18790255984697__1745845032d19fab2e").insertAfter("p.above_reg_form");
});

/*7/8/2025 Courses Plus remove none instructor tag on filters*/
$(document).ready(function(){
window.addEventListener("onCoursesRendered", () =>{
  if(document.querySelector('select#tagsFilter')) {
    document.querySelectorAll('select#tagsFilter option').forEach((element) => {
    if(element.getAttribute('data-attr-tagname') != 'all' && !element.getAttribute('data-attr-tagname').includes('Class Instructor')) {
      element.remove();
    }
  })
  }
  });
});

/* JM added for CTA button for homepage Shop by Collection 7-28-2025*/
$(document).ready(function() {
 $('<div class="featured-heading-button desktop"><a class="feature-collection-btn" href="/collections/"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a></div>').insertAfter("div#shopify-section-template--19421335748665__1663803219cdbd5186 .section-header__title");
 $(' <a class="feature-collection-btn mobile" href="/collections/"><svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 24 24" fill="none"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>').appendTo('div#shopify-section-template--19421335748665__1663803219cdbd5186 .section-header__title');
});


/* JM added for product to auto add to cart when viewed on PDP when the #autoadd parameter is present*/
$(document).ready(function() {
  if (window.location.hash === "#autoadd") {
    setTimeout(function() {
      const $addToCartButton = $(".template-product .payment-buttons button.btn.btn--full.add-to-cart");
      if ($addToCartButton.length) {
        $addToCartButton.trigger("click");
      }
    }, 4500);
  }
});

// $(document).ready(function() {
//   const params = new URLSearchParams(window.location.search);
//   if (
//     params.get("utm_content") === "Facebook_UA" &&
//     params.get("utm_source") === "facebook" &&
//     params.get("variant") === "43299866705977"
//   ) {
//     setTimeout(function() {
//       const $addToCartButton = $(".template-product .payment-buttons button.btn.btn--full.add-to-cart");
//       if ($addToCartButton.length) {
//         $addToCartButton.trigger("click");
//       }
//     },4500);
//   }
// });

/* JM added for welcome series discount code*/
$(document).ready(function() {
  if (window.location.hash === "#welcome-series") {
    $("ul#variantDiscountCodeList").css("display","block");
    $("ul#variantDiscountCodeList span.newDiscountCode").text("(with CRAFTINGFUN)");
  }
});

/*Quiz form*/
$(document).ready(function() {
  if (window.location.pathname === '/pages/whats-your-signature-cardmaking-style') {
    $(".page-width.page-width--narrow.page-content header.hc-header.section-header").css("display","none");
  }
});

/*JM added for PDP CTA A/B test 8/12/2025*/
$(document).ready(function() {
  if (window.location.href.indexOf("/products/hawaiian-shores-dual-tip-pens") > -1 || window.location.href.indexOf("/products/mini-poppy-stamp-set") > -1 || window.location.href.indexOf("/products/daisy") > -1 ){
    setTimeout(function() {
      $(".template-product .add-to-cart.btn--secondary span").text("Try It Today");
    },3000);
  }
});

/* JM added for winback flow discount code*/
$(document).ready(function() {
  if (window.location.hash === "#winback-flow-3") {
    $("ul#variantDiscountCodeList").css("display","block");
  }
});

/* JM added customer gallery trigger button when banner is click 9/2/2025*/
$(document).ready(function() {
  $(".switch-apps-gallery-hero__content").on("click", function() {
    const btn = $("a.btn.btn--primary.button.button--primary.button--solid.Button.Button--primary.rendered").get(0);
    if (btn) btn.click(); // native click
  });
});

/*JM added for PDP CTA A/B test batch 2 9/23/2025*/
$(document).ready(function() {
  if (window.location.href.indexOf("/products/craft-your-life-project-kit-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/build-a-garden-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/craft-a-flower-monthly-subscription-plan") > -1 || window.location.href.indexOf("/products/stampwheel-2-0") > -1 || window.location.href.indexOf("/products/9x12-ultra-sticky-mat-grid") > -1  || window.location.href.indexOf("cts/stampwheel") > -1 ){
    setTimeout(function() {
      if(window.location.href.indexOf("/products/stampwheel-2-0-next-level-stamping") > -1) {
        $(".template-product .add-to-cart.btn--secondary span").text("Pre-order today");
      } else {
        $(".template-product .add-to-cart.btn--secondary span").text("Try it Today");
        console.log(43343, window.location.href)
      }
    },3000);
  }
});

// 10222025-001 START: update CTA button for Original Sticky Mat 
$(document).ready(function() {
  setTimeout(function () {
    $(".CTA-get-offer").text("Get Offer");
  },4000);
});
// 10222025-001 END

// 10292025-001 START: New to Altenew page (custom with Impulse theme) and not page builder 
$(document).ready(function() {
  $('.collection-list-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 3000,
      dots: true,
      infinite: false,
      adaptiveHeight: true,
      arrows: false
  });
});
// 10292025-001 END